import React, { useEffect } from 'react';
import { AppRouter } from './routers/AppRouter';

import Aos from 'aos';
import 'aos/dist/aos.css';

function App() {
	useEffect(() => {
		Aos.init({
			delay: 300,
		});
		Aos.refresh();
	}, []);
	return <AppRouter />;
}

export default App;
